import { tv } from 'tailwind-variants';

export default tv({
    slots: {
        base: 'inline-flex items-center gap-1.5 font-bold select-none',
        label: 'truncate',
        icon: 'shrink-0',
    },
    variants: {
        color: {
            primary: '',
            accent: '',
            pink: '',
            info: '',
            success: '',
            warning: '',
            error: '',
            neutral: '',
            gradient: '',
        },
        variant: {
            solid: '',
            outline: 'border',
            soft: '',
        },
        size: {
            xs: {
                base: 'px-1.5 py-1 text-xs',
                icon: '-ml-0.25 size-4',
            },
            sm: {
                base: 'px-2 py-1 text-sm',
                icon: '-ml-0.5 size-4',
            },
            md: {
                base: 'px-2 py-1.5 text-sm',
                icon: '-ml-0.5 size-4',
            },
            lg: {
                base: 'px-3 py-1.5 text-base',
                icon: '-ml-1 size-5',
            },
        },
    },
    compoundVariants: [
        {
            color: 'primary',
            variant: 'solid',
            class: {
                base: 'bg-black text-white',
            },
        },
        {
            color: 'primary',
            variant: 'outline',
            class: {
                base: 'border-black text-black',
            },
        },
        {
            color: 'accent',
            variant: 'solid',
            class: 'bg-accent/10 text-accent',
        },
        {
            color: 'accent',
            variant: 'outline',
            class: 'border-accent text-accent',
        },
        {
            color: 'pink',
            variant: 'solid',
            class: 'bg-pink text-white',
        },
        {
            color: 'pink',
            variant: 'outline',
            class: 'border-pink text-pink',
        },
        {
            color: 'info',
            variant: 'solid',
            class: 'bg-accent text-white',
        },
        {
            color: 'info',
            variant: 'outline',
            class: 'border-accent text-accent',
        },
        {
            color: 'info',
            variant: 'soft',
            class: 'bg-accent/10 text-accent',
        },
        {
            color: 'success',
            variant: 'solid',
            class: 'bg-success text-white',
        },
        {
            color: 'success',
            variant: 'outline',
            class: 'border-success text-success',
        },
        {
            color: 'success',
            variant: 'soft',
            class: 'bg-success/10 text-success',
        },
        {
            color: 'warning',
            variant: 'solid',
            class: 'bg-warning text-white',
        },
        {
            color: 'warning',
            variant: 'outline',
            class: 'border-warning text-warning',
        },
        {
            color: 'warning',
            variant: 'soft',
            class: 'bg-warning/10 text-warning',
        },
        {
            color: 'error',
            variant: 'solid',
            class: 'bg-danger text-white',
        },
        {
            color: 'error',
            variant: 'outline',
            class: 'border-danger text-danger',
        },
        {
            color: 'error',
            variant: 'soft',
            class: 'bg-danger/10 text-danger',
        },
        {
            color: 'neutral',
            variant: 'solid',
            class: {
                base: 'bg-gray-200 text-black',
            },
        },
        {
            color: 'neutral',
            variant: 'outline',
            class: {
                base: 'border-black text-black',
            },
        },
        {
            color: 'gradient',
            variant: 'solid',
            class: {
                base: 'bg-pink-gradient text-white',
            },
        },
        {
            color: 'gradient',
            variant: 'outline',
            class: {
                base: 'border-pink text-black',
            },
        },
    ],
    defaultVariants: {
        color: 'primary',
        variant: 'solid',
        size: 'md',
    },
});
